exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media print{\r\n    .no-print{\r\n        display: none;\r\n    }\r\n\r\n    .row{\r\n        page-break-inside: avoid;\r\n    }\r\n}", ""]);
